
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/surveys/[surveyId]",
      function () {
        return require("private-next-pages/surveys/[surveyId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/surveys/[surveyId]"])
      });
    }
  